angular.module('impactx.catalog').controller('CheckedOutCatalogListCtrl', [
    '$scope',
    'dataGen',
    '$routeParams',
    'searchFilter',
    '$redirect',
    'CatalogCheckinService',
    'ToastService',
    'selectedListItems',
    'DefaultPicture',
    '$config',
    '$securityManager',
    '$mdDialog',
    'CheckoutCatalogActions',
    'ToolbarService',
    'OneTimeDataTransporter',
    'DownloadService',
    'TranslationService',
    'AppConfiguration',
    'SearchFilter',
    CheckedOutCatalogListController]);

function CheckedOutCatalogListController($scope, dataGen, $routeParams, searchFilter,
                                         $redirect, CatalogCheckinService, ToastService,
                                         selectedListItems, DefaultPicture, $config, $securityManager,
                                         $mdDialog, CheckoutCatalogActions, ToolbarService, OneTimeDataTransporter,
                                         DownloadService, TranslationService, AppConfiguration, SearchFilter) {
    var self = this;

    if ($routeParams.cmrlId > 0) {
        var dataFromTransporter = OneTimeDataTransporter.getData();
        var cmrlName = dataFromTransporter ? dataFromTransporter.cmrlName : "";
        searchFilter.getSearchFilterData().cmrlId = {value: $routeParams.cmrlId, label: cmrlName};
        $scope.cmrlName = cmrlName;
        $scope.numberOfErrorItems = $routeParams.numberOfErrorItems;
    }
    else if ($routeParams.productLabelKeyValue)
    {
        searchFilter.getSearchFilterData().cmrlId = {};
        $scope.productLabelKeyValue = $routeParams.productLabelKeyValue;
        $scope.numberOfItems = $routeParams.numberOfItems;
        searchFilter.getSearchFilterData().productLabelKey = {value: $routeParams.productLabelKeyValue};
    }
    else {
        searchFilter.getSearchFilterData().cmrlId = {};
        searchFilter.getSearchFilterData().productLabelKey = {};
    }

    $scope.catId = $routeParams.id;
    $scope.hideProductFamily = true;
    $scope.hideCategory = true;
    $scope.hideSupplier = true;
    $scope.selectedProducts = [];
    $scope.showSearch = {value: true};
    this.useSearchFilterFactoryForDrilldown = true;
    this.exists = searchFilter.exists;

    searchFilter.clearSearchInput();
    SearchFilter.resetSearch();
    if (searchFilter.getSearchFilterData()) {
        searchFilter.getSearchFilterData().drillDowns = [];
    }
    $scope.dynamicItems = selectedListItems.createDynamicItems($scope, 'data.products');

    self.setLocalFilterSettings = function () {

        $scope.no_result = impactX.valueOrDefault($scope, 'data.products.length', 0) < 1;

        //Copy values
        $scope.filters = [];
        $scope.filters.push(searchFilter.getSearchFilterData().vcatalogId);
        $scope.searchFilter = searchFilter;

        $scope.fixedFilters = searchFilter.getSearchFilterData();
        $scope.searchFilter = searchFilter;

        self.facetResults = [];
    };

    this.hasOneProductSelected = function () {
        return $scope.selectedProducts && $scope.selectedProducts.length === 1 && self.hasNoCompilationArticleSelected();
    };

    this.hasProductsSelected = function () {
        return $scope.selectedProducts && $scope.selectedProducts.length > 0;
    };

    this.hasProductsSelectedDeny = function () {
        return self.hasProductsSelected() &&
                $scope.selectedProducts.some(function (e) {return !e.isDenied});
    };

    this.hasNoProductSelected = function () {
        return !$scope.selectedProducts || !$scope.selectedProducts.length || $scope.selectedProducts.length === 0;
    };

    this.hasCompilationArticleSelected = function () {
        return self.hasCompilationArticleLicence() && ($scope.selectedProducts.filter(function (product) {
            return product.isCompilationArticle;
        }).length > 0);
    };

    this.hasNoCompilationArticleSelected = function () {
        return ($scope.selectedProducts.filter(function (product) {
            return product.isCompilationArticle;
        }).length <= 0);
    };

    this.canCreateCompilationArticle = function () {
        return self.hasCompilationArticleLicence() && self.hasNoCompilationArticleSelected() && self.hasNoProductSelected();
    };

    this.hasOneCompilationArticleSelected = function () {
        return self.hasCompilationArticleLicence() && $scope.selectedProducts && $scope.selectedProducts.length === 1 && self.hasCompilationArticleSelected()
    };

    this.hasCompilationArticleLicence = function () {
        return $scope.data.hasCompilationArticleLicence;
    };

    this.hasNoProductAndNoRuleSelected = function () {
        return self.hasNoProductSelected() && !$scope.cmrlName;
    };

    this.canPrintCmrl = function () {
        return self.hasNoProductSelected() && $scope.cmrlName;
    };

    this.canPrintNoCmrl = function () {
        return self.hasNoProductSelected() && !$scope.cmrlName;
    };

    this.canDeleteCmrlFilter = function () {
        return self.hasNoProductSelected() && $scope.cmrlName;
    };

    this.getProductDetailLink = function () {
        return $scope.selectedProducts[0] ? "editproduct/" + $scope.selectedProducts[0].id + "/" + $scope.catId : "";
    };

    this.getProductRelationLink = function () {
        return $scope.selectedProducts[0] ? "editproductrelations/" + $scope.selectedProducts[0].id + "/" + $scope.catId + "/" + new Date().getTime() : "";
    };

    this.getProductMediaLink = function () {
        return $scope.selectedProducts[0] ? "editproductmedia/" + $scope.selectedProducts[0].id + "/" + $scope.catId : "";
    };

    this.getNewProductLink = function () {
        return "editproduct/0/" + $scope.catId;
    };

    this.getProductGroupsLink = function () {
        return "editproductgroups/" + $scope.catId;
    };

    this.getCompilationArticleLink = function () {
        return $scope.selectedProducts[0] ? "compilationarticle/" + $scope.catId + "/" + $scope.selectedProducts[0].id : "";
    };

    this.getNewCompilationArticleLink = function () {
        return "compilationarticle/" + $scope.catId + "/0";
    };

    this.getRuleCheckLink = function () {
        return "catalogrulecheckcheckedoutitemlist/" + $scope.catId;
    };

    this.getSelectedItemsLabel = function () {
        return $scope.selectedProducts && $scope.selectedProducts.length > 0 ? $scope.selectedProducts.length + ' ' + $scope.trns.selected : "";
    };

    this.export = function () {
        var form = document.createElement('form');
        form.action = $config.sourceURL + "/catalog/export/checkout";
        form.method = 'POST';
        form.target = '_blank';
        form.style.display = 'none';

        var input = document.createElement('input');
        input.type = 'text';
        input.name = 'token';
        input.value = $securityManager.getToken();

        var paramId = document.createElement('input');
        paramId.name = 'id';
        paramId.value = $scope.catId;

        var paramFilter = document.createElement('input');
        paramFilter.name = 'filters';
        paramFilter.value = angular.toJson(searchFilter.getSearchFilterData());

        var submit = document.createElement('input');
        submit.type = 'submit';
        submit.id = 'submitForm';

        form.appendChild(input);
        form.appendChild(paramId);
        form.appendChild(paramFilter);
        form.appendChild(submit);
        document.body.appendChild(form);

        $('#submitForm').click();

        document.body.removeChild(form);
    };

    this.canImportProductData = function () {
        return AppConfiguration.get("enableCatalogToViewCopy") && $scope.catId > 0;
    };

    this.importProductData = function (event) {
        $mdDialog.show({
            controller: "ImportProductDataCtrl",
            controllerAs: "importProductDataCtrl",
            templateUrl: "modules/catalog/templates/import-product-data.tmpl.html",
            parent: angular.element(document.body),
            targetEvent: event,
            clickOutsideToClose: true,
            bindToController: true,
            locals: {
                headerLabel: $scope.trns.importProductData,
                importLabel: $scope.trns.import,
                cancelLabel: $scope.trns.cancel,
                dropzoneLabel: $scope.trns.importProductDataDropzone,
                catId: $scope.catId
            }
        }).then(function () {
            self.search();
        });
    };

    self.search = function () {
        self.unSelectAll();

        var transferObject = {
            id: $scope.catId,
            filters: searchFilter.getSearchFilterData()
        };

        dataGen.postAsForm($scope, transferObject, '/catalog/list/checkedoutcatalog').then(function (data) {
            var attributeSearch;

            if (impactX.isDefined($scope, 'data.searchError')) {
                ToastService.openStandardToast($scope.data.searchError);
            }

            $scope.no_result = impactX.valueOrDefault($scope, 'data.products.length', 0) < 1;
            $scope.filters = [];
            $scope.filters.push(searchFilter.getSearchFilterData().vcatalogId);
            $scope.fixedFilters = searchFilter.getSearchFilterData();
            $scope.searchFilter = searchFilter;

            attributeSearch = $scope.data.attributeSearch;

            if (attributeSearch) {
                self.facetResults = attributeSearch.facetResults;
                self.guidedFacetResult = attributeSearch.guidedFacetResult;
            }
            else {
                self.facetResults = [];
            }
            $scope.buttonDefinition = [
                {
                    icon: 'mdi-close',
                    labelFunction: self.getSelectedItemsLabel,
                    action: self.unSelectAll,
                    condition: self.hasProductsSelected
                },
                {
                    label: $scope.trns.selectAll,
                    action: self.selectAll,
                    type: 'dialogaction',
                    condition: self.hasNoProductSelected
                },
                {label: $scope.trns.print, action: self.print, type: 'dialogaction', condition: self.canPrintNoCmrl},
                {
                    label: $scope.trns.print,
                    action: self.printResult,
                    type: 'dialogaction',
                    condition: self.canPrintCmrl
                },
                {
                    label: $scope.trns.productGroups,
                    linkFunction: self.getProductGroupsLink,
                    type: 'link',
                    condition: self.hasNoProductSelected,
                    process: 'EditCatalog'
                },
                {
                    label: $scope.trns.newProduct,
                    linkFunction: self.getNewProductLink,
                    type: 'link',
                    condition: self.hasNoProductAndNoRuleSelected,
                    process: 'EditCatalog'
                },
                {
                    label: $scope.trns.newCompilationArticle,
                    linkFunction: self.getNewCompilationArticleLink,
                    type: 'link',
                    condition: self.canCreateCompilationArticle,
                    process: 'EditCompilationArticle'
                },
                {
                    label: $scope.trns.checkIn,
                    action: self.checkIn,
                    type: 'dialogaction',
                    condition: self.hasNoProductAndNoRuleSelected,
                    process: 'Catalog'
                },
                {
                    label: $scope.trns.ruleCheck,
                    linkFunction: self.getRuleCheckLink,
                    type: 'link',
                    condition: self.hasNoProductSelected,
                    process: 'CatalogRule'
                },
                {
                    label: $scope.trns.details,
                    linkFunction: self.getProductDetailLink,
                    type: 'link',
                    condition: self.hasOneProductSelected,
                    process: 'EditCatalog'
                },
                {
                    label: $scope.trns.details,
                    linkFunction: self.getCompilationArticleLink,
                    type: 'link',
                    condition: self.hasOneCompilationArticleSelected,
                    process: 'EditCompilationArticle'
                },
                {
                    label: $scope.trns.relations,
                    linkFunction: self.getProductRelationLink,
                    type: 'link',
                    condition: self.hasOneProductSelected,
                    process: 'EditCatalog'
                },
                {
                    label: $scope.trns.mediaAndAttachments,
                    linkFunction: self.getProductMediaLink,
                    type: 'link',
                    condition: self.hasOneProductSelected,
                    process: 'EditCatalog'
                },
                {
                    label: $scope.trns.deny,
                    action: self.denyAll,
                    type: 'dialogaction',
                    condition: self.hasProductsSelectedDeny
                },
                {
                    label: $scope.trns.assignDefaultPicture,
                    action: self.openDefaultPictureDialog,
                    type: 'dialogaction',
                    condition: self.hasNoProductSelected,
                    process: 'EditCatalog'
                },
                {
                    label: $scope.trns.assignDefaultPicture,
                    action: self.openDefaultPictureDialog,
                    type: 'dialogaction',
                    condition: self.hasProductsSelected,
                    process: 'EditCatalog'
                },
                {
                    label: TranslationService.get('printList'),
                    action: self.export,
                    type: 'dialogaction',
                    condition: self.hasNoProductSelected,
                    process: 'EditCatalog'
                },
                {
                    label: $scope.trns.importProductData,
                    action: self.importProductData,
                    type: 'dialogaction',
                    condition: self.canImportProductData,
                    process: 'CatalogImportProductData'
                }
            ];
            ToolbarService.setButtons($scope.buttonDefinition);
        });
    };

    self.unSelectAll = function () {
        $scope.selectedProducts.forEach(function (product) {
            product.selected = false;
        });
        $scope.selectedProducts.length = 0;
    };

    self.deleteCmrlFilter = function () {
        $redirect.redirectTo(null, "/checkedoutcataloglist/" + $scope.catId);
    };

    self.deleteProductLabelFilter = function () {
        $redirect.redirectTo(null, "/checkedoutcataloglist/" + $scope.catId);
    };

    // ugly but I don't wanna refactor all templates to work with the functions assigned to the controller
    $scope.search = function () {
        self.search();
    };

    self.reload = function () {
        //$scope.selectedProducts.length = 0;
        $scope.selectedProducts = [];
        this.search();
    };

    self.selectProduct = function (product) {
        if (product.selected) {
            var index = $scope.selectedProducts.indexOf(product);
            if (index > -1) {
                $scope.selectedProducts.splice(index, 1);
            }
        }
        else {
            $scope.selectedProducts.push(product);
        }
        product.selected = !product.selected;
    };

    self.denyAll = function (event) {
        var proIds = [];
        for (var i = 0; i < $scope.selectedProducts.length; i++) {
            proIds.push($scope.selectedProducts[i].id)
        }

        CheckoutCatalogActions.denyAll(event, proIds).then(function (answer) {
            if (answer != 'closed') {
                self.reload();
            }
        });
    };


    self.selectAll = function () {
        $scope.data.products.forEach(function (product) {
            $scope.selectedProducts.push(product);
            product.selected = true;
        });
    };

    self.toggleDrillDown = function (item) {
        searchFilter.toggleDrillDown(item);
        $scope.search();
    };

    self.checkIn = function () {
        var scope = {};
        CatalogCheckinService.checkIn(scope, $scope.catId).then(function () {
            $redirect.redirectTo(null, "/cataloglist");
            ToastService.openStandardToast(scope.trns.checkInStarted);
        })
    };

    self.toggleSearch = function () {
        $scope.showSearch.value = !$scope.showSearch.value;
    };

    self.openDefaultPictureDialog = function (event) {
        var products = $scope.selectedProducts.length > 0 ? $scope.selectedProducts : [];
        var productIds = [];
        angular.forEach(products, function (product) {
            productIds.push(product.id);
        });

        return DefaultPicture.showDefaultPictureDialog($scope.catId, productIds, event)
    };

    self.printResult = function () {
        print($routeParams.cmrlId, $scope.catId);
    };

    self.print = function () {
        print(0, $scope.catId);
    };

    var print = function (cmrliId, catId) {
        var form = document.createElement('form');
        form.action = $config.sourceURL + "/print/list/exportpro";
        form.method = 'POST';
        form.target = 'print';
        form.style.display = 'none';

        var inputt = document.createElement('input');
        inputt.type = 'text';
        inputt.name = 'token';
        inputt.value = $securityManager.getToken();

        var input = document.createElement('input');
        input.name = 'cmrliId';
        input.value = cmrliId;

        var input2 = document.createElement('input');
        input2.name = 'catId';
        input2.value = catId;

        var submit = document.createElement('input');
        submit.type = 'submit';
        submit.id = 'submitForm';

        form.appendChild(input);
        form.appendChild(input2);
        form.appendChild(inputt);
        form.appendChild(submit);
        document.body.appendChild(form);

        $('#submitForm').click();

        document.body.removeChild(form);
    };


    //DIRTY ...
    if (!searchFilter.wasInitialized) {
        //We need configuration for search filters. Otherwise weird results.
        searchFilter.initSearchFilter().then(function () {
            self.setLocalFilterSettings();
            self.search();
        });
    }
    else {
        self.setLocalFilterSettings();
        self.search();
    }

    var checkFilter = function (filter) {
        return !!(filter && (filter.value || filter.selected))
    };


    self.anyFiltersSet = function () {
        var filterdata = $scope.fixedFilters;
        if (filterdata) {
            if (filterdata.drillDowns && filterdata.drillDowns.length > 0) {
                return true;
            }
            return !!searchFilter.searchInput
                || checkFilter(filterdata.supplier)
                || checkFilter(filterdata.manufacturer)
                || checkFilter(filterdata.contractNo)
                || checkFilter(filterdata.supplierNo)
                || checkFilter(filterdata.category)
                || checkFilter(filterdata.sort)
                || checkFilter(filterdata.priceRange.minValue)
                || checkFilter(filterdata.priceRange.maxValue);
        }
        return false;
    };
}
